export default "__VITE_ASSET__5d9c04ef__"